// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","mainContent":"App_mainContent__mD5IX"};